import { render, staticRenderFns } from "./FormsCreateModal.vue?vue&type=template&id=7a6e4e1c&"
import script from "./FormsCreateModal.vue?vue&type=script&lang=js&"
export * from "./FormsCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports